import { DataBlock, DataGroupOverviewType, DataGroupSideBar } from './types/types'

export const MydataBlocks: DataBlock = {
  title: 'Sprint report',
  filters: [
    {
      label: 'Assignee',
      key: 'assignee',
      type: 'autocomplete',
      placeholder: 'Select assignee',
      options: [
        { label: 'Everyone', key: '' },
        { label: 'Arno Nederlof', key: 'Arno Nederlof' },
        { label: 'Rosa Elfering', key: 'Rosa Elfering' },
        { label: 'Max van Loosbroek', key: 'Max van Loosbroek' },
        { label: 'Vy Long Tran', key: 'Vy Long Tran' },
        { label: 'Max Groenenboom', key: 'Max Groenenboom' },
        { label: 'Amber van Dam', key: 'Amber van Dam' }
      ],
      value: '',
      hidden: false
    },
    { label: 'Sprint', key: 'sprint', type: 'text', value: 'current', hidden: false },
    { label: 'Project', key: 'project', type: 'text', value: 'PT', hidden: true }
  ],
  displayBlocks: [
    {
      id: 1,
      title: 'Tickets per status',
      description: 'Display of tickets per team member.',
      displayType: 'table',
      selectedFields: [
        { displayName: 'Assignee', key: 'assignee', type: 'string' },
        { displayName: 'To do (SP)', key: 'toDoSP', type: 'number' },
        { displayName: 'In progress (SP)', key: 'inProgressSP', type: 'number' },
        { displayName: 'Done (SP)', key: 'doneSP', type: 'number' }
      ],
      conclusion: 'There is no **conclusion** yet.',
      path: ['reports', 'kpi', 'productKPIs', 'issuesPerStatusCategory']
    },
    {
      id: 2,
      title: 'Sprint burndown',
      description: 'This line chart shows the total story points over time along with the optimal burn tempo. If we are above the optimal then we are behind schedule and if below we are ahead of schedule.',
      displayType: 'line',
      selectedFields: [
        { displayName: 'datetime', key: 'datetime', type: 'date' },
        { displayName: 'optimalSprint', key: 'optimalSprint', type: 'date' },
        { displayName: 'storyPointsLeft', key: 'storyPointsLeft', type: 'number' }
      ],
      xAxis: { displayName: 'Time', key: 'datetime', type: 'date' },
      yAxes: [
        { displayName: 'Optimal sprint', key: 'optimalSprint', type: 'date' },
        { displayName: 'SP left', key: 'storyPointsLeft', type: 'number' }
      ],
      path: ['reports', 'kpi', 'productKPIs', 'burndown']
    }
  ]
}

export const OrganisationaldataBlocks: DataBlock = {
  title: 'TaaS Report',
  filters: [{
    label: 'Relation',
    key: 'relationId',
    type: 'text',
    value: 160,
    hidden: true
  }],
  displayBlocks: [
    {
      id: 1,
      title: 'All Taas Report data',
      description: 'Table displays id, serial, team id, client id, month, shipped at, start at, end at and relation for selected organisation',
      displayType: 'table',
      selectedFields: [
        { displayName: 'Id', key: 'id', type: 'number' },
        { displayName: 'Serial', key: 'serial', type: 'string' },
        { displayName: 'Team id', key: 'teamId', type: 'string' },
        { displayName: 'Client id', key: 'clientId', type: 'string' },
        { displayName: 'Month', key: 'month', type: 'date' },
        { displayName: 'Shipped at', key: 'shippedAt', type: 'date' },
        { displayName: 'Start at', key: 'startAt', type: 'date' },
        { displayName: 'EndAt', key: 'endAt', type: 'date' },
        { displayName: 'Relation', key: 'relation', type: 'string' }
      ],
      path: ['reports', 'allReports', 'taasReport']
    }
  ]
}

export const MyDataGroups: DataGroupSideBar = {
  title: 'All Data',
  dataBlocks: [{
    id: 1,
    title: 'Sprint report',
    category: 'KPIs'
  },
  {
    id: 2,
    title: 'Coming soon',
    category: '[Category]'
  }]
}

export const OrganisationalDataGroups: DataGroupSideBar = {
  title: 'Test company B',
  dataBlocks: [{
    id: 1,
    title: 'Taas Report',
    category: 'Taas'
  }]
}

export const MyDataGroupsOverview: DataGroupOverviewType[] = [
  {
    id: 1,
    title: 'All Data',
    updatedAt: '12-01-2025'
  }
]
